import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Paper, Typography, Card, CardContent, Button, Stack, Box, Dialog } from '@mui/material';
import axios from '../../axiosInstance';
import FlipbookModal from '../../components/FlipbookModal';
import RecommendedBooks from '../../components/RecommendedBooks';
import SearchBox from '../../components/SearchBox';
import defaultThumbnail from '../../assets/logo4.png';
import { styled } from '@mui/system';

// ArticleDetails_Self.js
const ArticleDetails_Self = ({ onSearch, initialQuery }) => {
  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [courseIds, setCourseIds] = useState(null); // Store the username
  const [collegeId, setCollegeId] = useState(null); // Store the username
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();
  const location = useLocation();
  const [pdfUrl, setPdfUrl] = useState(null);

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);

  
  const { id: bookId } = useParams();

  const [item, setItem] = useState(null);
  const [recommendedBooks, setRecommendedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookDetails = async () => {
      if (!bookId) return;  // Ensure we have a valid bookId
      setLoading(true);
      try {
        const response = await axios.get(`https://backend.scholarkart.in/api/books/${bookId}`);
        const book = response.data; // Assuming the response contains the book data
        
        setItem({
          id: book._id,
          title: book.bookTitle || 'No title available',
          authors: book.authorName || 'Unknown',
          year: book.publicationYear || 'Unknown',
          type: book.bookType || 'Unknown',
          ISBN: book.ISBN || 'Unknown',
          publisher: book.publisherName || 'Unknown',
          course: book.courseDetails?.courseId?.courseName || 'Unknown',
          subject: book.courseDetails?.subjectId?.subjectName || 'Unknown',
          semester: book.courseDetails?.semester || 'Unknown',
          thumbnail: book.coverImageURL || defaultThumbnail,
          abstract: book.bookDescription || 'No description available',
          detailLink: book.pdfURL || '#', // Link to the book PDF
        });

   
      } catch (err) {
        setError('Failed to fetch book details.');
      } finally {
        setLoading(false);
      }
    };
    fetchBookDetails();
    
  }, [bookId]);





    
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setUsername(user.username);  // Set username if user is logged in
        setCourseIds(user.courseIds);
        setCollegeId(user.collegeId);
        setDisplayname(user.displayname);
      }
    }, []);
  
  


    if (loading) return <Typography>Loading...</Typography>;
    if (error) return <Typography>{error}</Typography>;


    const SearchResultsWrapper = styled(Box)(({ theme }) => ({
      width: '60%', // Default for larger screens
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minHeight: '500px',
      [theme.breakpoints.down('md')]: {
        width: '100%', // Full width on medium screens or smaller
        paddingLeft: 5,
        paddingRight: 5,
      },
    }));
    
    const YouTubeResultsWrapper = styled(Box)(({ theme }) => ({
      width: '40%', // Default for larger screens
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minHeight: '500px',
      [theme.breakpoints.down('md')]: {
        width: '100%', // Full width on medium screens or smaller
        paddingLeft: 0,
      },
    }));


  return (
    <main className="flex-grow p-1">


    <div className="bg-gray-100 text-gray-900 flex flex-col min-h-full">

    <div className="flex-1 flex flex-col p-1 bg-gradient-to-br from-gray-50 to-gray-200">
    {collegeId && <SearchBox />}

<br />
<Box
  className="main-content"
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' }, // column on mobile, row on desktop
  }}
>
      <SearchResultsWrapper>
      <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
        {item.title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' }, // Stack on mobile
          gap: 2,
        }}
      >
            <img src={item.thumbnail} alt="Thumbnail" style={{ width: '30%', height: '45%' }} />
            <Box sx={{ flex: 1 }}>
            <Stack spacing={0.75}>
              <Typography sx={{ color: 'text.secondary' }}><strong>Book Type:</strong> {item.type}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>Author/s:</strong> {item.authors}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>Publisher:</strong> {item.publisher}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>Publication Year:</strong> {item.year}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>ISBN:</strong> {item.ISBN}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>Course:</strong> {item.course}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>Semester:</strong> {item.semester}</Typography>
              <Typography sx={{ color: 'text.secondary' }}><strong>Subject:</strong> {item.subject}</Typography>
              <Button
                onClick={() => setPdfUrl(item.detailLink)}
                sx={{ 
                  color: 'white', 
                  background: '#FFB300', 
                  marginTop: 2,
                  border: '1px solid transparent', 
                  '&:hover': {
                    backgroundColor: '#FFA500', 
                    borderColor: '#007bff', 
                  }
                }}
              >
                <strong>📘Read Full-Text</strong>
              </Button>
              </Stack>
                    {/* Flipbook Modal for PDF */}
                      {pdfUrl && (
                        <Dialog
                          open={Boolean(pdfUrl)}
                          onClose={() => setPdfUrl(null)}
                          maxWidth="lg"
                          fullWidth
                        >
                          <FlipbookModal
                            pdfUrl={pdfUrl}
                            onClose={() => setPdfUrl(null)} 
                          />
                        </Dialog>
                      )}
            </Box>
          </Box>
          <Box sx={{ marginTop: 2 }}>
            <Typography sx={{ color: 'primary.main' }}><strong>Description:</strong> {item.abstract}</Typography>
          </Box>
          </SearchResultsWrapper>

          <YouTubeResultsWrapper>
            <RecommendedBooks
              course={item.course}
              subject={item.subject}
              semester={item.semester}
              currentBookId={item.id}
            />
          </YouTubeResultsWrapper>
</Box>

          </div>
          </div>
          </main>
  );
};

export default ArticleDetails_Self;

